module.exports = __webpack_public_path__ + "static/media/auth-cover.a35acf87.jpg";